import { createUseStyles } from 'react-jss';

import { zBatchGridOverlay } from 'utils/ui-helpers/stackingContexts';
import { ITheme } from 'types';
import { CDN_140 } from 'configs/constants';

const useStyles = createUseStyles<ITheme>(theme => ({
  mainContent: {
    '--top-gutter': props => props?.isWeb ? '40px' : '0px',
    '--bottom-gutter': '0px',
    '--side-gutter': '0px',
    position: 'relative',
    padding: 'var(--top-gutter) var(--side-gutter) var(--bottom-gutter)',
    width: '100%',
    borderRadius: theme.radiuses.r16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > [class^="uploaderWrapper"]': {
      outline: 'none',
    },
  },
  mainContentGridWrap: {
    position: 'absolute',
    top: 'var(--top-gutter)',
    right: 'var(--side-gutter)',
    bottom: 'var(--bottom-gutter)',
    left: 'var(--side-gutter)',
    maxHeight: '100%',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    ...theme.scrollbars.main,
  },
  mainContentGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(min(260px, 100%/3), 1fr))',
    gridGap: 12,
    '& > div': {
      position: 'relative',
      paddingTop: '100%',
    },
  },
  gridItemContainer: {
    borderRadius: theme.variables.mainBorderRadius,
    background: theme.colors.backgrounds.tint1,
    overflow: 'hidden',
    userSelect: 'none',
    cursor: props => props?.pointer ? 'pointer' : '',
  },
  gridOverlay: {
    zIndex: zBatchGridOverlay,
    '@media(hover: hover)': {
      '&:hover': {
        background: '#4d54651a',
      },
    },
  },
  hoverGridItem: {
    '@media(hover: hover)': {
      '&:hover': {
        '& $gridBtnsContainer': {
          opacity: 1,
        },
      },
    },
  },
  selectedGridItem: {
    '& $gridOverlay': {
      background: '#4d54651a',
    },
    '& $gridBtnsContainer': {
      opacity: 1,
      cursor: 'pointer',
    },
  },
  gridImageWrap: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: props => props?.width,
    height: props => props?.height,
    background: `url(${CDN_140}/64814455576311042242.svg) center center/cover no-repeat`,
  },
  gridImage: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
  },
  watermark: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: theme.spacings.s0,
    left: theme.spacings.s0,
  },
  doneIcon: {
    '& svg': {
      width: '70%',
      height: '70%',
      marginLeft: 3,
      marginTop: 2,
    },
    '& path': {
      fill: '#282b36',
      stroke: '#282b36',
    },
  },
  gridBtnsContainer: {
    opacity: props => props?.isWeb ? 0 : 1,
  },
  selectCheckbox: {
    minHeight: 24,
    '& > span': {
      width: 24,
      height: 24,
    },
  },
}));

export default useStyles;
